import { render, staticRenderFns } from "./InsurerPaintMaterials.vue?vue&type=template&id=9bc75936"
import script from "./InsurerPaintMaterials.vue?vue&type=script&lang=js"
export * from "./InsurerPaintMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bc75936')) {
      api.createRecord('9bc75936', component.options)
    } else {
      api.reload('9bc75936', component.options)
    }
    module.hot.accept("./InsurerPaintMaterials.vue?vue&type=template&id=9bc75936", function () {
      api.rerender('9bc75936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurer/InsurerPaintMaterials.vue"
export default component.exports